var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 187.09 132.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1d1d1b;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "katman_2",
    "data-name": "katman 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "katman_1-2",
    "data-name": "katman 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73,112.77v19.67h0c-2.15.21-4.34.33-6.56.33A66.39,66.39,0,1,1,66.41,0c2.22,0,4.41.12,6.56.33h0V20h0A46.82,46.82,0,0,0,19.53,66.38a47,47,0,0,0,46.88,46.86,47.45,47.45,0,0,0,6.56-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.75,56.25h38.36V76.54H134.75a47,47,0,0,0,45.75,36.7,47.88,47.88,0,0,0,6.59-.47h0v19.67h0c-2.18.21-4.37.33-6.59.33A66.39,66.39,0,1,1,180.5,0c2.22,0,4.41.12,6.59.33h0V20h0a48.22,48.22,0,0,0-6.59-.47,47,47,0,0,0-45.75,36.72Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCe);
export default __webpack_public_path__ + "static/media/ce.9554f24cf3708bd928393700bdbeb7d6.svg";
export { ForwardRef as ReactComponent };